<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-tair"
  [title]="'P00030.dashboard.card.title' | translate"
  [mode]="getTemperatureContent()"
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
